import { createContext, useContext, ReactNode, useState } from "react";
import DbService from "../services/DbService";
import { useHandleError } from "../hooks/useHandleError";

interface TeacherContextType {}

const TeacherContext = createContext<TeacherContextType | undefined>(undefined);

interface TeacherProviderProps {
  children: ReactNode;
}

export const TeacherProvider: React.FC<TeacherProviderProps> = ({
  children,
}) => {
  const handleError = useHandleError();

  return (
    <TeacherContext.Provider value={{}}>{children}</TeacherContext.Provider>
  );
};
